import { useState } from "react";
import useTranslator from "../hooks/useTranslator";

const videoData = [
    {
        title: "howToInviteTenants",
        description: "learnHowToSendInvitationsDirectlyToYourTenants",
        url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/howToInviteTenant.mp4",
        duration: "1:20"
    },
    {
        title: "howToAddProperties",
        description: "addAndManagePropertiesEasily",
        url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/howToAddProperties.mp4",
        duration: "0:50"
    },
    {
        title: "sharePropertiesOrTenantsWithOtherWorkspaces",
        description: "shareTenantsOrPropertiesAcrossWorkspaces",
        url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/sharingPropertiesOrTenants.mp4",
        duration: "0:52"
    },
    {
        title: "howToInviteNewMembersToOurWorkspace",
        description: "addTeamMembersAndManageTheirPermissions",
        url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/howToinviteNewMembers.mp4",
        duration: "1:34"
    },
    {
        title: "rentedPropertiesWithAddendums",
        description: "managePropertiesWithRentalContractsAndAddendums",
        url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/propertiesRentedWithAddenda.mp4",
        duration: "1:43"
    },
    // {
    //     title: "howToGetANonPaymentInsurancePolicy",
    //     description: "getNonPaymentInsuranceToProtectYourProperties",
    //     url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/propertiesRentedWithAddenda.mp4",
    //     duration: "1:43"
    // },
];

const HelpCenter = () => {
    const { _t } = useTranslator();

    return (
        <div className="main-page-wrapper help-center-page">
            <h1>{_t("helpCenter")}</h1>
            <p className="page-description">{_t("learnHowToUseSkorStepByStep")}</p>
            <h3>{_t("gettingStarted")}</h3>
            <div className="video-section">
                {videoData.slice(0, 3).map((video, index) => (
                    <VideoCard key={index} video={video} t={_t} />
                ))}
            </div>

            <h3 className="advanced-features-title">{_t("advancedFeatures")}</h3>
            <div className="video-section">
                {videoData.slice(3).map((video, index) => (
                    <VideoCard key={index} video={video} t={_t} />
                ))}
            </div>
        </div>
    )
}

export default HelpCenter

const VideoCard = ({ video, t }) => (
    <div className="video-card">
        <div className="thumbnail">
            <video controls
            >
                <source src={video.url} type="video/mp4" />
            </video>
        </div>

        <div className="video-content">
            <h4>{t(video.title)}</h4>
            <p className="description">{t(video.description)}</p>
            <p>{video.duration}</p>
        </div>
    </div>
    );